import theme from 'theme'

export const mobileTopPadding = `calc(${theme.mobileTopbarHeight} + 24px)`
